import styled from 'styled-components';

export const UploadLogoContainer = styled.article`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const UploadLogoHeader = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
`;

export const Input = styled.input``;

export const InputLabel = styled.label`
  border-radius: 18px;
  box-shadow: 0px 0px 10px 0px #00000026;
  text-align: center;
  color: #fff !important;
  font-size: 16px;
  font-weight: bold;
  text-transform: uppercase;
  padding: 0.6rem 1.8rem;
  background: #ffcb29;
  cursor: pointer;

  &.disabledButton {
    background: #ccc;
    cursor: not-allowed;

    &:hover {
      background: #ccc;
    }
  }

  &:hover {
    background-color: #020c90;
  }
`;

export const UploadLogoActionButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: auto;
`;

export const UploadLogoCancelButton = styled.button`
  margin-right: 20px;
  font-size: 16px;
  text-align: center;
  text-transform: uppercase;
  font-weight: 700;
  color: #ffcb29;
  padding: 10px 20px;
  border: 1px solid #ffcb29;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
  cursor: pointer;

  &:hover {
    background-color: #020c90;
    color: #fff;
    border: 1px solid #020c90;
  }
`;

export const UploadLogoSaveButton = styled.button`
  text-align: center;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 700;
  color: #fff;
  padding: 10px 30px;
  border: none;
  border-radius: 18px;
  background: #ffcb29;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
  cursor: pointer;

  &:hover {
    background-color: #020c90;
  }

  &:disabled {
    background-color: #ccc;
    color: #f9f9f9;
    cursor: not-allowed;
  }
`;

export const UploadLogoTitle = styled.h2`
  color: #272727;
  font-size: 23px;
  font-weight: 700;
  max-width: 80%;

  @media all and (max-width: 800px) {
    max-width: 100%;
    text-align: center;
    margin-bottom: 10px;
  }

  span {
    color: #f00;
  }
`;

export const UploadLogoList = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
`;

export const UploadLogoListItem = styled.li`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  margin: 0.5rem;
  padding: 0.5rem;
  width: 118px;
  height: 118px;
  border-radius: 0.5rem;
  transition: all 0.2s ease-in-out;
  cursor: pointer;

  @media all and (max-width: 550px) {
    width: 80px;
    height: 80px;
  }
`;

export const CloseImageButton = styled.button`
  width: 30px;
  height: 30px;
  font-size: 1rem;
  font-weight: bold;
  color: #fff;
  border: none;
  background: #0f0;
  border-radius: 20px;
  background: #ffcb29;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
  cursor: pointer;

  &:hover {
    background-color: #020c90;
  }
`;

export const ErrorMessage = styled.p`
  color: #f00;
  font-size: 14px;
  width: 100%;
`;
